import { CourseType } from 'common-proptypes'
import { connect } from 'react-redux'
import Spinner from 'components/Spinner'
import CatastrophicErrorDisplay from 'components/CatastrophicErrorDisplay'
import CourseDetailsRenderer from './CourseDetailsRenderer.jsx'

const mapStateToProps = state => {
  return {
    loading: state.course.get('pending'),
    errors: state.course.get('errors').toList().toArray(),
  }
}
export default connect(mapStateToProps)(class CourseDetails extends React.PureComponent {
  static propTypes = {
    loading: PropTypes.bool,
    errors: PropTypes.arrayOf(PropTypes.shape({
      message: PropTypes.node,
      date: Date,
    })),
    course: CourseType,
  }

  render() {
    const {
      loading,
      errors,
      course,
    } = this.props
    if(loading && !course) {
      return <Spinner />
    }
    if(errors && errors.length) {
      if(errors.length === 1 && errors[0].responseCode === 404) {
        return (
          <CatastrophicErrorDisplay
            title={(
              <>
                <div style={{ fontSize: '1.75em', lineHeight: 1 }}><span role="img" aria-label="not found">🔍🤔</span></div>
                <div>This course could not be found</div>
              </>
            )}
            description="The requested course could not be found."
            resolution={null}
          />
        )
      }
      return (
        <CatastrophicErrorDisplay
          title={(
            <>
              <div style={{ fontSize: '1.75em', lineHeight: 1 }}><span role="img" aria-label="ouchie">🐞</span></div>
              <div>Something went wrong</div>
            </>
          )}
          description="An error ocurred while trying to load course info."
          errors={errors}
        />
      )
    }

    if(course) {
      return <CourseDetailsRenderer course={course} />
    }
    return null
  }
})
